import { render, staticRenderFns } from "./addBankCard.vue?vue&type=template&id=76a665fb&scoped=true"
import script from "./addBankCard.vue?vue&type=script&lang=js"
export * from "./addBankCard.vue?vue&type=script&lang=js"
import style0 from "./addBankCard.vue?vue&type=style&index=0&id=76a665fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a665fb",
  null
  
)

export default component.exports